module.exports = __webpack_public_path__ + "img/sys-icon-3.3c4681c.png";